// src/runtimeConfig.js
// Runtime configuration fetched from the backend (GET /api/config/) before the
// app boots. Nothing environment-specific is compiled into the bundle.

const CONFIG_URL = "/api/config/";

let runtimeConfig = null;

function normalise(raw) {
  const b2c = raw?.b2c || {};
  const support = raw?.support || {};
  const appInsights = raw?.app_insights || {};
  const idealPostcodes = raw?.ideal_postcodes || {};
  const clientPortal = raw?.client_portal || {};

  return {
    systemName: raw?.system_name || "XLerate",
    appEnvironment: (raw?.app_environment || "").toUpperCase(),
    appVersion: raw?.app_version || "unknown",
    support: {
      email: support.email || "",
      phone: support.phone || "",
    },
    b2c: {
      clientId: b2c.client_id || "",
      authorityDomain: b2c.authority_domain || "",
      authorityUrl: b2c.authority_url || "",
      susiFlow: b2c.susi_flow || "",
      passwordResetFlow: b2c.password_reset_flow || "",
      apiScope: b2c.api_scope || "",
      protocolMode: b2c.protocol_mode || "AAD",
      spaReturnUrl: b2c.spa_return_url || "",
    },
    appInsights: {
      connectionString: appInsights.connection_string || "",
    },
    idealPostcodes: {
      apiKey: idealPostcodes.api_key || "",
      baseUrl: idealPostcodes.base_url || "https://api.ideal-postcodes.co.uk/v1",
    },
    clientPortal: {
      clientId: clientPortal.client_id || "",
      signInFlow: clientPortal.sign_in_flow || "",
      passwordResetFlow: clientPortal.password_reset_flow || "",
      authorityDomain: clientPortal.authority_domain || "",
      authorityUrl: clientPortal.authority_url || "",
      apiScope: clientPortal.api_scope || "",
      publicUrl: clientPortal.public_url || "",
      protocolMode: clientPortal.protocol_mode || "AAD",
    },
  };
}

export async function loadRuntimeConfig() {
  if (runtimeConfig) return runtimeConfig;

  const response = await fetch(CONFIG_URL, {
    method: "GET",
    headers: { Accept: "application/json" },
    cache: "no-store",
    credentials: "same-origin",
  });

  if (!response.ok) {
    throw new Error(
      `Failed to load runtime configuration from ${CONFIG_URL} (HTTP ${response.status}).`
    );
  }

  runtimeConfig = normalise(await response.json());
  return runtimeConfig;
}

export function getRuntimeConfig() {
  if (!runtimeConfig) {
    throw new Error(
      "Runtime configuration has not been loaded. Call loadRuntimeConfig() first."
    );
  }
  return runtimeConfig;
}

// Test helper: lets unit tests seed config without a network call.
export function setRuntimeConfigForTests(raw) {
  runtimeConfig = normalise(raw);
  return runtimeConfig;
}
